import { DatePipe } from '@angular/common';
import { ApplicationRef, ChangeDetectorRef } from '@angular/core';
import { AfterViewInit, Component, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatCalendar, MatCalendarCellCssClasses } from '@angular/material/datepicker';
import { IAppointment, IAppointmentListResponse, IDashboardMidwifePayload, IMumRequested } from 'src/app/models/dashboard.models';
import { GenericCalendarComponent } from 'src/app/pages/shared-components/generic-calendar/generic-calendar.component';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
  selector: 'app-my-calendar',
  templateUrl: './my-calendar.component.html',
  styleUrls: ['./my-calendar.component.scss']
})
export class MyCalendarComponent implements OnInit, AfterViewInit {

  @Input() dashboard: IDashboardMidwifePayload;
  appointments: Array<IAppointment> = [];
  appointmentsBackup: Array<IAppointment> = [];
  signedUpMum: Array<IMumRequested> = [];
  selectedDate: Date = new Date();
  addAppointmentBtn: boolean = false;
  today = new Date();

  appDates :number[] = []; // BG Color orange
  dueDates :number[] = []; // BG Color pink

  monthAndYear: any;

  @ViewChild(GenericCalendarComponent) calendar: GenericCalendarComponent;

  constructor(
    private dashboardService: DashboardService,
    private renderer: Renderer2,
    private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.appointmentsBackup = this.dashboard.appointments;
    this.today.setHours(0,0,0,0);
    this.monthAndYear = this.datePipe.transform(this.today,"MMMM y");
    this.onSelect(null);
    this.getMumsList();
  }

  getMumsList(){
    this.signedUpMum = [];

    for(let i=0; i<this.dashboard.bookings.length; i++) {
      let found: boolean = false;
      this.signedUpMum.forEach(mum=>{
        if(mum.mumId == this.dashboard.bookings[i].mumBooked[0].mumId)
        {
          found = true;
        }
      });
      if(!found)
      {
        this.signedUpMum.push(this.dashboard.bookings[i].mumBooked[0]);
      }
    }

    this.dueDates = [];
    for(let i=0; i<this.signedUpMum.length; i++){
      let date = new Date(this.signedUpMum[i].dueDate)
      date.setHours(0,0,0,0);
      this.dueDates.push(date.getTime());
    }
  }

  onSelect(event: any){
    if(event){
      this.selectedDate = event;
      this.selectedDate.setHours(0,0,0,0);
    }
    this.appointments = [];
    this.addAppointmentBtn = this.today <= this.selectedDate ? false : true;
    this.appointmentsBackup.forEach(app=>{
      let dateConverted = new Date(app.date);
      dateConverted.setHours(0,0,0,0);
      if(dateConverted.getTime() === this.selectedDate.getTime())
      {
        this.appointments.push(app);
      }
    });
  }

  getAppointmentsByMonth(monthAndYear: any){
    
    if(monthAndYear){
      this.monthAndYear = monthAndYear;
    }

    let body = {
      monthAndYear: this.monthAndYear,
      offset: 0
    }

    this.appointmentsBackup = [];

    this.dashboardService.getAppointmentListByMonth(body)
    .subscribe((res: IAppointmentListResponse)=>{
      this.appointmentsBackup =  res.payload;
      console.log("Fetch Appointment By Month:", this.appointmentsBackup);

      this.appDates = [];

      for(let i=0; i<this.appointmentsBackup.length; i++){
        let date = new Date(this.appointmentsBackup[i].date)
        date.setHours(0,0,0,0);
        this.appDates.push(date.getTime());
      }

      this.onSelect(null);
      this.calendar.populateDateList();
    },err=>{
      console.error("Fetch Appointment By Month Failed:", err);
    });
  }

  ngAfterViewInit() {
    const btn = document.querySelectorAll('.mat-calendar-previous-button,.mat-calendar-next-button');
    if (btn) {
      Array.from(btn).forEach(button => {
        this.renderer.listen(button, "click", (event) => {
          this.getAppointmentsByMonth(null);
        });
      })
    }
  }

  refreshData(appointment: IAppointment){
    this.appointmentsBackup.push(appointment);
    this.onSelect(new Date(appointment.date));
  }
}
